import axios from 'axios'
import store from '@/store'

// 统一的 axios 实例：后端基址、表单编码、凭证策略只在这里配置一次。
const http = axios.create({
  baseURL: store.state.WebURL,
  withCredentials: false,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
})

// 把对象序列化成 a=b&c=d（后端约定的表单格式）
export function urlencode(params: Record<string, any> = {}): string {
  return Object.keys(params)
    .filter(k => params[k] !== undefined && params[k] !== null)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&')
}

// 统一请求入口。后端以 query 参数读取为主，参数一律拼在 URL 上（与历史行为一致）。
export function request(
  servlet: string,
  params: Record<string, any> = {},
  method: 'get' | 'post' = 'get'
) {
  const query = urlencode(params)
  const url = servlet + (query ? (servlet.includes('?') ? '&' : '?') + query : '')
  return method === 'post' ? http.post(url) : http.get(url)
}

export default http
